import { MenuProps } from 'antd';

import { securityConfig } from '@/shared/security/hasPermission';
import { OrganizationLevelType } from '@/shared/organizations/enums';
export type MenuItem = Required<MenuProps>['items'][number];

export type TransformCallback<T = any> = (data: T, clickableBy: string) => MenuItem;

export interface LazyMenuItem {
  key: string;
  label: string;
  trigger?: LazyMenuFunction;
  clickableBy?: OrganizationLevelType;
  toTransformMenu?: TransformCallback;
  security?: securityConfig;
}

export type LazyMenuFunction = () => {
  unwrap: () => Promise<any>;
};

// порядок уровней от корня к листу — нужен для сравнения глубины
export const LEVEL_ORDER: OrganizationLevelType[] = [
  OrganizationLevelType.ROOT,
  OrganizationLevelType.REGION,
  OrganizationLevelType.DISTRICT,
  OrganizationLevelType.ORGANIZATION,
  OrganizationLevelType.STRUCTURAL_DIVISION,
  OrganizationLevelType.FACILITY,
];

export const getLevelDepth = (level: OrganizationLevelType): number =>
  LEVEL_ORDER.indexOf(level);

export type OrgRef = {
  id: string;
  name: string;
};
export type ItemMode = 'dropdown' | 'collapsed' | 'static';
